import styled from '@emotion/styled'
import { Box, Table, TableCell, TableHead, Typography } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../util'

const distance = '132'

export const RootWrap = styled(Box)(`
	&.exportToPPT {padding:0;}
	&.exportToPPT > div{box-shadow:none}
	&.exportToPPT .list > div {overflow:hidden;}
	${exportToPPT_tableCss}
	
	&.exportToPPT {
		& .brandCategory {border: 0;}
		& .brandCategory > div {padding: 0;}
		& .tabWrapper {display:none;}
		
		& .list {flex-direction: column;}
        & .segmentOfSegmentOverviewRow:before { 
			position: relative;
			left: 0;
			border: 0;
			width: 100%;
			padding: 0 0 5px 0;
			margin: 10px 0 0 0;
			min-height: auto;
		}
        & .segmentOfSegmentOverviewRow { 
			border: 0;
		}
	}

    &.exportToPPTProgression {
        & .segmentOfSegmentOverviewRowProgression { background: #fff !important; box-shadow: none; padding-bottom:2px; }
        & .segmentOfSegmentOverviewRowProgression > div { padding:0; height: auto; line-height: 1; }
        & .segmentOfSegmentOverviewRowProgression .graphRow { padding-bottom:0; }
        & .segmentOfSegmentOverviewRowProgression .heading { padding-bottom:2px; }
	}

`)

export const ContentWrap = styled(Box)(`
	background: #fff;
	margin-left: ${distance}px;
	width: calc(100% - ${distance}px);

  &.slider-init {
    margin-left : 0;
    width : 100%;
  }
`)

export const HeaderWrap = styled(Box)(`
	display: flex;
	align-items: center;
	width: 100%;
`)

export const BoxRow = styled(Box)(`
  
`)

export const BoxCell = styled(Box)(`

`)

export const ButtonWrapper = styled(Box)(`
  display: flex; 
  justify-content: space-between;
  width: calc(100% - 200px);
  height: 0; 
  position: absolute; 
  top: calc(50% - 40px);
  left:200px; 
  z-index: 10;

  & button {
    background:rgba(246, 246, 245, 1);
    cursor: pointer;
    position: static;
    width: 24px;
    height: 36px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;

    border: 0;
    & svg {
      fill:rgba(104, 104, 103, 1);
    }
  }
`)


export const TableWithSliderOuterWrapper = styled(Box)(`
`)


export const TableWithSliderWrapper = styled(Box)(`
  border: 1px solid rgb(210, 213, 218);
  margin-bottom: 30px;
  overflow: visible;
	display: flex;
	width: 100%;
  flex-direction: column;
  border-radius: 4px;

  & .slider-container {
    margin-left: 200px;
  }
  & .slider-container.header {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid rgb(210, 213, 218);
    & .slick-slide {
      padding: 0 12px;
    }
  }
  & .slider-container.body {
    width: 100%;
    height: 40px;
    font-size: 13px;
    font-weight: 400;
  }

  & .carousel-with-sticky-first {
    position: relative;
  }
  & .first-fixed {
    // position: sticky;
    display: flex;
    align-items: center;
    position: absolute;
    width:200px;
    height: 40px;
    top:0;
    left: 0;
    z-index: 10;
    padding: 8px 12px;
    margin-left: -200px;
    border-bottom: 1px solid rgb(210, 213, 218);
  }
  .dotted {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 40px;
    line-height: 40px;
    display: block !important;
    padding-top: 0;
    padding-bottom: 0;
  }
`)

export const HeaderTab = styled(Box)(`
    display: flex;
	align-items: center;
	background: #F7F7F9;
	padding: 6px 10px;
	overflow: hidden;
	width: 100%;
	& .tab {
		padding: 5px 10px;
		font-size: 12px;
		font-weight: 400; // 300;
		margin-right: 2px;
		cursor: pointer;
		&.active {
			background: #fff;
			font-weight: 600; // 500;
		}
	}
`)

export const SegmentWrap = styled(Box)(`
  display : flex;

  & .segmentOfSegmentOverviewRow:before {
    content : none;
  }
`)

export const SliderWrap = styled(Box)(`
  width: calc(600px  - 132px);
  flex : 1;
  min-width : 0;
  position : relative;

  & .slick-list .slick-track {
    // display : flex;
    // flex-direction : column;
  }
`)

export const SegmentRow = styled(Box)(props => `
	font-size: 14px;
	font-weight: 400; // 300;
	position: relative;
	// min-height: 60px;
	display:flex;
	flex-direction: column;
	justify-content: center;
  // margin-bottom : 4px;

	display: flex;
  flex-direction: row;
	& > div {
		width: 100%;
	}

  & * {min-height: ${props.ht} !important; }

	& .segmentLabel {
		position: absolute;
		left: -${distance}px;
    width: ${distance}px;
    height: auto;
		display: flex;
		align-items: center;
		padding: 5px 6px;
		line-height:16px;
		top: -1px;
		left: 0;
		margin: -1px 5px -1px -137px;
    opacity: 0;
	}

	&:before {
		content: attr(data-age);
		position: absolute;
		left: -${distance}px;
		width: ${distance}px;
		height: calc(100% + 4px);
		display: flex;
		align-items: center;
		padding: 5px 6px;
		line-height:16px;
		top: -1px;
		left: 0;
		margin: -1px 5px -1px -137px;
	}
	& .outerText{
		font-size: 12px;
		margin-left: 6px;
		font-weight: 400; // 300;
	}
	& ul.barRoot { background: #f1f1f1;  }

  &.noVal:before {
    content : none;
  }
`)

export const SegmentRowContent = styled(Box)(`
	display: flex;
	align-items: center;
	margin: 0;
	position: relative;
`)

export const TitleCell = styled(Box)(`
  min-width: 120px;   
  font-size: 14px;
  font-weight: 400;
  padding: 5px 6px;
  line-height: 16px;
  display: flex;
  position: relative;
  top: 0;
  margin: 0 0;
  flex-shrink: 0;
  min-height : 39px;
  align-items : center;
`);

export const TitleWrap = styled(Box)(`
  width : 132px;
  display : flex;
  flex-direction : column;
`);

export const BarWrap = styled(Box)(`
	width: 100%;
  
  display : flex;
  align-items : center;
  gap : 4px;

	// & .barRoot, .barItemRoot, .barSliceWrap, .barSlice {
	// 	height: 30px !important;
	// }
	& .barSlicePercentage{
		font-weight: 400; // 300;
		font-size: 14px;
	}

  &.legends {
    align-items : baseline;

    & .slick-slider {
      position : initial;

      .slick-arrow {
        top : 40%;

        // &.slick-prev {
        //   left : 10.5%;
        // }
      }
    }
  }

  &.slider-wrapper {
    display : block;

    .slick-track {     
      display : flex;
      gap : 9px; 
      // .slick-slide {
      //   margin-right : 9px;
        
      //   &:last-child {
      //     margin-right : 0;
      //   }
      // }
    }
  }
`)

export const IssuesWrap = styled(Box)(`
	position: absolute;
	left: calc(100% + 5px);
	display: flex;
	align-items: center;
	& .radio {
		width: 10px;
		height: 10px;
		min-width: 10px;
		min-height: 10px;
		border: 1px solid #7E7E7E;
		margin-right: 4px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		& .box {
			width: 4.5px;
			height: 4.5px;
			min-width: 4.5px;
			min-height: 4.5px;
			background: #7E7E7E;
			border-radius: 50%;
		}
	}
	& .radio-text {
		font-size: 12px;
		font-weight: 400; // 300;
		white-space: nowrap;
	}
`)

export const LegendWrap = styled(Box)(`
	width: 100%;
	display: flex;
	justify-content: end;
	padding: 5px 5px 10px 5px;
`)

export const TabSection1 = styled(Box)(`
    display: flex;
    width: 100%;
`)

export const TabSection2 = styled(Box)(`
    display: flex;
    width: 100%;
    flex-direction:column;
`)

export const ProgressionFiltersWrapper = styled(Box)(`
    display: flex;
    width: 100%;
    margin-bottom:10px;

    & button:hover {
        background-color:transparent !important;
    }
`)

export const BrandHealthSection = styled(Box)(`
	display: flex;
	flex-direction:column;
	width:100%;
	margin-bottom:14px;
`)

export const HeadingSection = styled(Box)(`
    display: flex;
    height:40px;
    line-height:40px;
    padding:0 10px;
    border-bottom:1px #D8D8D6 solid;
    color: #000;
    font-size: 14px;
    font-weight: 600;;
`)

export const ContentSection = styled(Box)(`
    display: flex;
    flex-direction: column;
    padding:0 10px 10px 10px;
`)

export const SubHeadingSection = styled(Typography)(`
    font-size: 12px;
    font-weight: 600; // 500;
    width:100%;
    padding: 10px 0 0 120px;
`)

export const ChartRow = styled(Box)(`
    display: flex;
    width: 100%;
    padding: 5px 5px 5px 0;
	& .barRoot {max-width: 100%;}
`)

export const RowName = styled(Box)(`
    text-transform: capitalize;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 120px;
    padding-right: 10px;
    font-weight: 400; // 300;
    font-size: 14px;
    line-height: 13px;
    text-align:right;
`)

export const RowBar = styled(Box)(
  ({ colorAndOpacity, visible }) =>`
    width: 32%;
    height: 32px;
    display: flex !important;
    justify-content: center;
    align-items: center;
    border-radius : 7px;
    font-weight : 500;
    background-color : ${colorAndOpacity.color};
    color : ${colorAndOpacity.textColor};
    visibility : ${visible};
    // box-shadow: 0 0 0 2px inset #fff;
    border: 4px solid #fff;
    border-width: 4px 2px;
`)

export const LegendText = styled(Box)(`
    width: 31%;
    line-height : 16px;
    font-weight : 500;
    font-size : 14px;
    text-align: center;
    padding: 8px 3px;
`)

export const TableWrapper = styled(Box)(`
  border : 1px solid #D2D5DA;
  border-radius: 4px;
  overflow: clip;   
  border-collapse : separate;


  tbody tr:last-of-type {
    td {
      border-bottom : none;
    }
  }
`)


export const StyledTableHead = styled(Box)(`
  // position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;

  &.MuiTableHead-root tr th {
    padding : 10px 12px;
    border-bottom : 1px solid #D2D5DA;
    font-weight : 500;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // max-width: 122px;
    text-align: left;
    letter-spacing : normal;
    font-size : 14px;
  }

  & .slider-container.header{
    width: 200px;
  }

  & .sliderHeading{
    width: 200px;
  }
`)

export const BarWrapper = styled(Box)(({barWidth , bgColor}) => `
  height: 4px;
  background: #E7E7E6;
  border-radius: 50px;

  & .bar-filled {
    width : ${barWidth ? barWidth + '%' : '0'};
    height: 4px;
    border-radius: 50px;
    ${bgColor ? `background : ${bgColor}` : ''};
  }
`)

export const TableData = styled(Box)(`
    border-bottom : 1px solid #D8D8D6;
    font-size : 13px;
    padding : 8px 12px;
    height:40px;
`)

export const TdWrapper = styled(Box)( ({index , textColor}) => `
    ${index !== 0 ? `
      display : flex;
      gap : 10px;
      align-items : center;
      ` : ''};
    // ${textColor ? `color : ${textColor};  ` : ''}
`)

export const ToolTipColWrapper = styled(Box)(`
    display: flex;
    justify-content: space-between;
    align-items : center;
`)

export const TooltipRowName = styled(Box)(`
  font-size : 13px;
  font-weight : 500;
`)

export const ToolTipColName = styled(Box)(( {circleColor}) => `
  font-size : 13px;
  font-weight : 300;
  ${circleColor ? `
    display: flex;
    align-items: center;
    gap: 4px;

    &:before {
      content : '';
      width : 9px;
      min-width : 9px;
      height : 9px;
      border-radius : 50%;
      background : ${circleColor};
      display: block;
    }  
  ` : ''}
`)

export const ToolTipWrapper = styled(Box)(`
  display : flex;
  padding : 8px;
  flex-direction : column;
  font-size : 12px;
`)

export const ToolTipContainer = styled(Box)(
  (props) => `
  position : absolute;
  display: flex;
  top : 30px;
  flex-direction: column;
  z-index: 1;
  background: #fff;
  box-shadow: 0px 5px 12px 0px rgba(0, 0, 0, 0.18);
  width : 220px;
  border-radius : 4px;

  &:before {
    content: "";
    position: absolute;
    top: 40%;
    ${props.arrow ? 'left: 2px;' : 'right: -17px;'}
    transform: translateX(-50%) rotate(45deg);
    width: 18px;
    height: 14px;
    background: #fff;
    z-index: -1;
  }
`)

export const MultiSelectWrapper = styled(Box)((props) => `
  display:flex;
  width: calc(100%  - 100px);
`)

